import { FlexColumn } from '@make-software/cspr-design';
import React from 'react';
import { TaskCreateForm } from 'app/components/management/apps/tasks/create/task-create-form';
import { FormContainer, PageContainer, StyledCaption } from 'app/components/common/common-styles';
import { useTabsCtx } from 'app/components/management/apps/tabs-page-layout';

export const TaskCreatePage: React.FC = () => {
  const { setBreadcrumbs } = useTabsCtx();

  React.useEffect(() => {
    setBreadcrumbs([
      {
        label: 'Create new'
      }
    ]);
    return () => setBreadcrumbs([]);
  }, []);

  return (
    <PageContainer>
      <FlexColumn justify={'center'} align={'center'}>
        <StyledCaption />
        <FormContainer>
          <TaskCreateForm />
        </FormContainer>
      </FlexColumn>
    </PageContainer>
  );
};
